import axios from "axios";

const apiKeyCloak = axios.create({
  baseURL: process.env.REACT_APP_KEYCLOAK_BACKEND_HOST_API,
});

export default apiKeyCloak;
